var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"desktop"},[_vm._l((this.$store.state.desktop.frames),function(item){return _c('d-frame',{key:item.id,attrs:{"data":item}})}),(_vm.$store.state.desktop.safari.active)?_c('safari',{attrs:{"data":_vm.$store.state.desktop.safari}}):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }